import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from "react-router-dom";
import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import * as alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { Auth } from 'aws-amplify';
import { toast } from "react-toastify";
import { DataTableCustomStyles } from '../../../../../components/helper/dataTable.config';
import { Region, SBU, Country } from '../../../../../models';
import HRLogin from '../../../../../setup/auth/hr.component';
import LeftSideBar from '../../../../../components/common/hr/leftnav.component';
import TopNavBar from '../../../../../components/common/hr/topnav.component';
import DeleteButton from '../../../../../components/common/buttons/DeleteButton';
import EditButton from '../../../../../components/common/buttons/EditButton';
import { ValidateHRRole } from '../../../../../components/helper/validateRole';
import { ConvertResponseForId } from '../../../../../components/helper/commonfunctions'
import ImportDimension from '../../../../../components/common/import/dimensionsimport.component';
import { ProgressSpinner } from 'primereact/progressspinner';
import { graphQLGetAllData, graphQLFindRecordById } from '../../../../../components/helper/graphQLFunctions';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../../../graphql/mutations';
import * as queries from '../../../../../graphql/queries';

export default function Regions() {
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [checkCountryList, setCheckCountryList] = useState([]);
    const [isPageLoaded, setPageLoaded] = useState(false);

    // //State
    const [regionList, setRegionList] = useState([]);
    const [regionFilterList, setRegionFilterList] = useState([]);
    const [isShowImportPopup, setIsShowImportPopup] = useState(false);


    let navigateTo = useNavigate();

    const handleEditClick = (e, id) => {
        e.preventDefault();
        navigateTo('/hr/setting/createregions/' + id);
    };

    const handleDeleteClick = async (e, id) => {
        e.preventDefault();
        // const objDeleteProductGroup = await DataStore.query(Region, id);
        const objDeleteRegion = await graphQLFindRecordById('getRegion', id);


        alertify.confirm('Confirmation', 'Do you want to delete this record?', async function () {
            //Delete language
            // DataStore.delete(objDeleteProductGroup);

            await API.graphql({
                query: mutations.deleteRegion,
                variables: {
                    input: {
                        id: objDeleteRegion.id,
                        _version: objDeleteRegion._version,
                    }
                }
            });
            BindList();
            toast.success("Deleted");
        }
            , function () { });

    };

    // //*Column Name
    const DataTableColumns = [
        {
            name: 'SBUs',
            selector: row => row.sbu,
            sortable: true,
        },
        {
            name: 'Cluster',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Ref Code',
            selector: row => row.REF_CODE,
            sortable: true,
        },

        {
            name: 'Name',
            cell: (row) => (
                <>
                    <div className="flex gap-8">
                        {/* <Link onClick={(e) => handleEditClick(e, row.id)} ><EditButton /></Link>
                    <Link onClick={(e) => handleDeleteClick(e, row.id)} ><DeleteButton /></Link> */}
                        <Link onClick={(e) => handleEditClick(e, row.id)} ><EditButton /></Link>
                        {
                            ConvertResponseForId(checkCountryList, row.id) === row.id ?
                                <Link className="disabledCursor opacity-50" ><DeleteButton /></Link> :
                                <Link onClick={(e) => handleDeleteClick(e, row.id)} ><DeleteButton /></Link>
                        }

                    </div>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            center: true
        }
    ];

    //Search Region
    const searchRegion = (searchedText) => {
        if (searchedText.length > 1) {
            let data = [...regionFilterList]
            let filteredData = data.filter(e =>
                e.name.toLowerCase().includes(searchedText.toLowerCase()) ||
                e.sbu.toLowerCase().includes(searchedText.toLowerCase()) ||
                e.REF_CODE.toLowerCase().includes(searchedText.toLowerCase())
            )
            setRegionList(filteredData)
        } else {
            let data = [...regionFilterList]
            setRegionList(data)
        }
    }

    async function onLoad() {
        try {
            if (!ValidateHRRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    //onClick Close popup
    async function onClickCloseImportPopup() {
        setIsShowImportPopup(false);
        BindList();
    }


    async function BindList() {

        let finalData = [];
        // var regionResponse = await DataStore.query(Region, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });
        var regionResponse = await graphQLGetAllData('listRegions');
        regionResponse = regionResponse.sort((a,b)=>a.name.localeCompare(b.name));



        if (regionResponse.length > 0) {
            //product group data for delete enanble
            let countryLength = []
            // var countryResponses = await DataStore.query(Country);
            var countryResponses = await graphQLGetAllData('listCountries');

            countryResponses.map((response) => {
                let data = { id: response.region_id }
                countryLength.push(data)

            })
            setCheckCountryList(countryLength)

            regionResponse.forEach(async (item, i) => {
                // var SBUResponses = await DataStore.query(SBU, (c) => c.id.eq(item.SBU_id));

                var SBUResponses = await graphQLGetAllData('listSBUS', [{ id: { eq: item.SBU_id } }]);

                let data = {
                    "id": item.id,
                    "name": item.name,
                    "REF_CODE": item.REF_CODE,
                    "sbu": SBUResponses.length > 0 ? SBUResponses[0].name + " (" + SBUResponses[0].REF_CODE + ")" : "-"
                }

                finalData.push(data)
                if (i === regionResponse.length - 1) {
                    setRegionList(finalData)
                    setRegionFilterList(finalData)
                    setPageLoaded(true)
                }

            })
        } else {
            setRegionList([])
            setRegionFilterList([])
            setPageLoaded(true)
        }

    }

    useEffect(() => {
        onLoad();
        BindList();
    }, []);

    return (
        isAuthenticated ? (

            <div>
                <div className="pt-16">
                    <TopNavBar />
                    <LeftSideBar />
                    <div className="dashboard-main-wrapper pl-20 pr-4 mt-3">
                        <div className="flex flex-1 flex-wrap p-5 pb-4 px-0 top-action-wrapper">
                            <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                                <div className="md:flex block md:col-span-2 mb-4">
                                </div>
                                <div className="md:flex block mb-4">
                                    <h2 className="page-title">Clusters</h2>
                                </div>
                            </div>

                            <div className="md:flex flex-1 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side">
                                <div className="relative">
                                    <input onChange={(e) => searchRegion(e.target.value)} type="text" id="required-search" className="rounded-md border border-[#D0D5DD] focus:border-transparent w-full py-2.5 pl-3 bg-white text-gray-700 placeholder-gray-500 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-[#403E3C] dark:text-[#FFFFFF] dark:border-[#403E3C]" placeholder="Search..." />
                                </div>
                                <div className="md:flex block mb-4 gap-4">
                                    <Link to="/hr/settings" className="flex py-2 px-5 bg-[#FFF] hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-black transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] dark:border-[#4A5056] dark:bg-[#4A5056] dark:text-white">
                                        Back
                                    </Link>
                                    <Link onClick={() => {
                                        setIsShowImportPopup(true);
                                    }} className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] bg-black">
                                        Import
                                    </Link>
                                    <Link to="/hr/setting/createregions" className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] bg-black">
                                        Create
                                    </Link>
                                </div>

                            </div>
                        </div>
                        <div>
                            <div className={"block w-full pt-5"}>
                                {
                                    isPageLoaded &&

                                    <DataTable
                                        columns={DataTableColumns}
                                        data={regionList}
                                        customStyles={DataTableCustomStyles}
                                        pagination
                                        highlightOnHover
                                        paginationPerPage={10}
                                    />
                                }
                                {
                                    !isPageLoaded &&
                                    <div className='text-center py-10' >
                                        <ProgressSpinner style={{ width: '80px', height: '80px', zIndex: '9999' }} strokeWidth="3" fill="var(--surface-ground)" animationDuration=".8s" />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        isShowImportPopup &&
                        <ImportDimension
                            closePopup={onClickCloseImportPopup}
                            type={"Region"}
                        />
                    }
                </div>
            </div>

        ) : (
            <HRLogin sessionExpired={1} />
        )
    );

}
